import * as _ from 'lodash'
import Diagram from '../view/Diagram'

import { Result, valueOrThrow } from '../types/result'
import { network } from 'src/globals';
import { globalApp } from 'src/view/App';

export function runFunctionToResult<Args extends Array<any>, T>(f: (...args: Args) => T, ...args: Args): Result<T> {
  try {
    return { type: "value", value: f(...args) }
  } catch (e) {
    return { type: "error", error: e }
  }
}

export function runCodeToResult<T>(code: string, env: Object = {}): Result<T> {
  try {
    const envNames = Object.keys(env)
    // TODO: just plugged some stuff in below lol
    const f = new Function('_', 'Diagram', 'webRequest', 'seconds', ...envNames, code)  // eslint-disable-line no-new-func
    return runFunctionToResult(f as any, _, Diagram, webRequest, seconds, ...Object.values(env))
  } catch (e) {
    return { type: "error", error: e }
  }
}



export const secondsInput = network.input(0)
const startSeconds = +(new Date()) / 1000

function seconds() {
  return secondsInput.get()
}

function updateSeconds() {
  secondsInput.set(+(new Date()) / 1000 - startSeconds)
  requestAnimationFrame(updateSeconds)
}
updateSeconds()




let responses = {} as {[url: string]: Result<string> | 'pending'}

export const responseCountInput = network.input(0)

function webRequest(url: string): string {
  const prevResponse = responses[url]
  if (prevResponse) {
    if (prevResponse === 'pending') {
      throw new Error("Pending!")
    } else {
      return valueOrThrow(prevResponse)
    }
  }

  var request = new XMLHttpRequest()
  request.open('GET', url, true)

  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      responses[url] = {type: 'value', value: request.responseText}
    } else {
      responses[url] = {type: 'error', error: new Error("Server returned " + request.status)}
    }
    network.sample(() => {
      responseCountInput.set(responseCountInput.get() + 1)
    })
    globalApp.forceUpdate()
  }

  request.onerror = function() {
    responses[url] = {type: 'error', error: new Error("Problem connecting")}
  };

  request.send();

  throw new Error("Pending!")
}


// WEBPACK FOOTER //
// ./src/model/run.ts